import { tokenService } from '@/services/tokenService';

const state = {
  tokens: []
}

const getters = {
  tokens: state => state.tokens,
}

const actions = {
  async fetchTokens({ commit }, { page, limit, status, query }) {
    commit('SET_LOADING', true);
    try {
      const response = await tokenService.getAll(page, limit, status, query);
      commit('SET_TOKENS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_TOKENS', []);
      commit('SET_LOADING', false);
    }
  },
  async deleteToken({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await tokenService.destroy(id);
      commit('DELETE_TOKEN', id);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
}

const mutations = {
  SET_TOKENS: (state, tokens) => state.tokens = tokens,
  DELETE_TOKEN: (state, id) => state.tokens = state.tokens.filter(token => token._id !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}